import DefaultTeamsFeatureList from './features/defaultTeamsFeatureList';
import TeamPremierFeatureList from './features/teamPremierFeatureList';
import FeatureRules from './rules/featureRules';
import summaryFeaturesTransformer from './summaryFeaturesTransformer';

export default summaryFeaturesTransformer([...DefaultTeamsFeatureList, ...TeamPremierFeatureList], {
  ...FeatureRules,
  // Add feature rule overrides below
});
